import * as React from "react";

export const EditIcon = ({ ...props }) => {
  return (
    <svg width={12} height={12} viewBox="0 0 12 12" fill="none" {...props}>
      <path
        d="M8.385 1.662a1.38 1.38 0 111.953 1.953l-6.59 6.588-2.684.732.733-2.684 6.588-6.589z"
        stroke="#01A8CE"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
